export default __webpack_public_path__ + "static/media/Shot_6.0000.b6245161.png";